/**
 * src/admin-ui/src/components/Footer.styles.ts
 *
 * Responsive fixed-footer styles.
 */

import { AppBar, Box, Button, Toolbar } from '@mui/material';
import { styled } from '@mui/material/styles';

export const FooterBar = styled(AppBar)(({ theme }) => ({
  top: 'auto',
  bottom: 0,
  color: theme.palette.common.white,
  background: 'linear-gradient(90deg, #8B4513 0%, #D2691E 100%)',
}));

export const FooterToolbar = styled(Toolbar)(({ theme }) => ({
  minHeight: 60,
  justifyContent: 'space-between',
  gap: theme.spacing(1),
  paddingInline: theme.spacing(1),
  [theme.breakpoints.up('sm')]: {
    paddingInline: theme.spacing(2),
  },
}));

export const DesktopNavigation = styled('nav')(({ theme }) => ({
  display: 'none',
  alignItems: 'center',
  gap: theme.spacing(0.5),
  [theme.breakpoints.up('sm')]: {
    display: 'flex',
  },
}));

export const MobileNavigation = styled(Box)(({ theme }) => ({
  display: 'flex',
  [theme.breakpoints.up('sm')]: {
    display: 'none',
  },
}));

export const FooterActions = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(0.5),
  '& .desktop-logout': {
    display: 'none',
  },
  [theme.breakpoints.up('sm')]: {
    '& .desktop-logout': {
      display: 'inline-flex',
    },
  },
}));

export const NavigationButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'active',
})<{ active?: boolean }>(({ theme, active }) => ({
  color: theme.palette.common.white,
  minHeight: 44,
  paddingInline: theme.spacing(1.5),
  backgroundColor: active ? 'rgb(255 255 255 / 0.18)' : 'transparent',
  '&:hover': {
    backgroundColor: 'rgb(255 255 255 / 0.14)',
  },
}));
